import { useState } from 'react';
import { faqs } from '@/mocks/homeData';

export default function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  return (
    <section id="faq" className="w-full py-14 md:py-20 bg-background-100">
      <div className="w-full max-w-3xl mx-auto px-4 md:px-6">
        <div className="text-center mb-8 md:mb-12">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950">
            常见问题
          </h2>
          <p className="text-sm md:text-base text-foreground-600 mt-2">
            关于女性分泌物和平台使用的常见疑问解答
          </p>
        </div>

        <div className="space-y-3">
          {faqs.map((faq, index) => (
            <div
              key={index}
              className="bg-background-50 rounded-xl overflow-hidden"
            >
              <button
                onClick={() => setOpenIndex(openIndex === index ? null : index)}
                className="w-full flex items-center justify-between px-5 py-4 md:py-5 text-left cursor-pointer hover:bg-background-100 transition-colors"
              >
                <span className="text-sm md:text-base font-medium text-foreground-950 pr-4">
                  {faq.question}
                </span>
                <div className={`w-6 h-6 flex items-center justify-center shrink-0 transition-transform duration-300 ${openIndex === index ? 'rotate-45' : ''}`}>
                  <i className="ri-add-line text-lg text-foreground-500"></i>
                </div>
              </button>
              <div
                className={`overflow-hidden transition-all duration-300 ${
                  openIndex === index ? 'max-h-96 opacity-100' : 'max-h-0 opacity-0'
                }`}
              >
                <p className="px-5 pb-5 text-sm md:text-base text-foreground-600 leading-relaxed">
                  {faq.answer}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}